'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./SEOAccordion.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SEOAccordion = function (props) {
    var isMultipleOpen = props.isMultipleOpen, accordionList = props.accordionList, hasBorder = props.hasBorder, arrowPosition = props.arrowPosition;
    return (React__default['default'].createElement("div", { className: "seo__accordion" }, accordionList.map(function (_a, index$1) {
        var id = _a.id, title = _a.title, body = _a.body, hasFaqSchema = _a.hasFaqSchema, isH3 = _a.isH3;
        var randomID = Math.random() * 100;
        return (React__default['default'].createElement("div", { className: index['default']("seo__accordion--item", hasBorder && "seo__accordion--item__border"), key: id, itemScope: hasFaqSchema, itemProp: hasFaqSchema ? 'mainEntity' : '', itemType: hasFaqSchema ? 'https://schema.org/Question' : '' },
            React__default['default'].createElement("input", { type: isMultipleOpen ? "checkbox" : "radio", id: "accordion__" + id + "_" + index$1 + "_" + randomID, name: "accordion__group" }),
            React__default['default'].createElement("label", { htmlFor: "accordion__" + id + "_" + index$1 + "_" + randomID, className: index['default']("seo__accordion--item--label", arrowPosition === "left" ? "arrow--left" : "arrow--right") }, isH3 ? React__default['default'].createElement("h3", null,
                " ",
                title) : title),
            React__default['default'].createElement("div", { className: "seo__accordion--item--body", itemScope: hasFaqSchema, itemProp: hasFaqSchema ? 'acceptedAnswer' : '', itemType: hasFaqSchema ? 'https://schema.org/Answer' : '' }, body())));
    })));
};

exports.SEOAccordion = SEOAccordion;
//# sourceMappingURL=SEOAccordion.js.map
